export type TranslationDownloadFailure =
  | 'expired'
  | 'notFound'
  | 'notReady'
  | 'unauthorized'
  | 'unavailable'
  | 'network'
  | 'rateLimited'
  | 'failed';

const errorCode = async (data: unknown): Promise<string | undefined> => {
  try {
    // Axios keeps JSON error responses as blobs when the request uses responseType: 'blob'.
    if (typeof Blob !== 'undefined' && data instanceof Blob) {
      if (data.size > 16384 || !data.type.includes('json')) return undefined;
      data = await data.text();
    }
    if (typeof data === 'string') data = JSON.parse(data);
    if (!data || typeof data !== 'object') return undefined;
    const code = (data as { data?: { code?: unknown } }).data?.code;
    return typeof code === 'string' ? code : undefined;
  } catch {
    return undefined;
  }
};

export const getTranslationDownloadFailure = async (error: unknown): Promise<TranslationDownloadFailure> => {
  const failure = error as { isAxiosError?: boolean; response?: { status?: number; data?: unknown } } | null;
  const response = failure?.response;
  if (!response) return failure?.isAxiosError ? 'network' : 'failed';

  const code = await errorCode(response.data);
  if (code === 'TRANSLATION_FILE_EXPIRED') return 'expired';
  if (code === 'TRANSLATION_JOB_NOT_FOUND') return 'notFound';
  if (code === 'TRANSLATION_NOT_READY') return 'notReady';
  if (code === 'TRANSLATION_DOWNLOAD_UNAVAILABLE') return 'unavailable';

  if (response.status === 401 || response.status === 403) return 'unauthorized';
  if (response.status === 404) return 'notFound';
  if (response.status === 409) return 'notReady';
  if (response.status === 429) return 'rateLimited';
  if (response.status && response.status >= 500) return 'unavailable';
  return 'failed';
};
